import { component } from "picoapp";
import { TablescapeState } from "../../state";
import { setQueryStringParameter } from "../../../scripts/lib/utils";

const hydrateProductData = (context, newProductData) => {
  const { product: productData } = context.getState();
  context.hydrate({ product: { ...productData, ...newProductData } });
};

export const productForm = component((node: HTMLElement, context) => {
  const variantsJSON = node.querySelector("#variants");
  if (!variantsJSON) return;
  const variantData = JSON.parse(variantsJSON.textContent);
  hydrateProductData(context, { variants: [...variantData] });
  const variantSelect: HTMLSelectElement =
    node.querySelector('select[name="id"]');
  if (!variantSelect) return;

  const getSelectedOptions = () => {
    const fieldsets: HTMLFieldSetElement[] = Array.from(
      node.querySelectorAll("fieldset")
    );
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value;
    });
  };

  const updateOptions = () => {
    const options = getSelectedOptions();
    hydrateProductData(context, { options });
    return options;
  };

  updateOptions();

  const updateVariant = () => {
    const options = updateOptions();
    const selectedVariant = variantData.find((variant) => {
      return variant.options.every((option) => options.includes(option));
    });

    node.dataset.productCurrentVariantId = selectedVariant.id;
    setQueryStringParameter("variant", selectedVariant.id);
    hydrateProductData(context, { selectedVariant, options });
    context.emit("tbsp:variant-selected", selectedVariant);
    return selectedVariant;
  };

  const updateSelectedOptionValue = () => {
    const {
      product: { options },
    }: TablescapeState = context.getState();
    const fieldsets: HTMLFieldSetElement[] = Array.from(
      node.querySelectorAll("fieldset")
    );
    fieldsets.forEach((fieldset, index) => {
      const selectedOptionValueNode = fieldset.querySelector(
        "[data-selected-option-value]"
      );
      const optionTextNode = selectedOptionValueNode.querySelector(
        "[data-tbsp-component='text']"
      );
      optionTextNode.innerHTML = options[index];
    });
  };

  const updateATCButton = () => {
    const buttons = Array.from(node.querySelectorAll("[data-button]"));
    const addToCart = node.querySelector("#add-to-cart") as HTMLDivElement;
    const waitlist = node.querySelector("#waitlist") as HTMLDivElement;
    const soldOut = node.querySelector("#sold-out") as HTMLDivElement;

    const {
      product: { selectedVariant },
      variantMetafields,
    } = context.getState();
    const waitlistDisabled =
      variantMetafields[`${selectedVariant.id}`]?.waitlist.disable;

    const showButton = (button: HTMLDivElement) => {
      if (!button) return;
      button.style.display = "block";
    };

    buttons.forEach((button: HTMLDivElement) => {
      button.style.display = "none";
      button.setAttribute("aria-hidden", "true");
    });
    if (selectedVariant.available) {
      showButton(addToCart);
    } else if (!selectedVariant.available && !waitlistDisabled) {
      showButton(waitlist);
    } else {
      showButton(soldOut);
    }
  };

  const updateKlarna = () => {
    const {
      product: { selectedVariant },
    } = context.getState();

    document
      .getElementsByTagName("klarna-placement")[0]
      ?.setAttribute("data-purchase-amount", selectedVariant.price);

    if ("KlarnaOnsiteService" in window) {
      (window as any).KlarnaOnsiteService =
        (window as any).KlarnaOnsiteService || [];
      (window as any).KlarnaOnsiteService.push({
        eventName: "refresh-placements",
      });
    }
  };

  node.addEventListener("change", function () {
    updateVariant();
    updateSelectedOptionValue();
    updateATCButton();
    updateKlarna();
  });
});
